import firebase from '@/firebase'
const db = firebase.firestore();

const store = {
  state: {
      indicePlanesBienestar:{},
  },
  getters: {
      indicePlanesBienestar: state => {
          return state.indicePlanesBienestar;
      }
  },
  mutations: {
      ASIGNA_INDICE_PLANES_BIENESTAR(state, planesBienestar){
          state.indicePlanesBienestar = planesBienestar;
      }
  },
  actions: {
      cargaIndicePlanesBienestar({commit,getters}){
          console.log("Store franquicia: " +getters.franquicia.id);
          return new Promise((resolve,reject) => {
            let docPath = db
            .collection("Franquicias")
            .doc(getters.franquicia.id)
            .collection("Indices")
            .doc("Planes_Bienestar")
            docPath.onSnapshot(doc => {
              //console.log('indice planes bienestar: ', doc.data())
              commit('ASIGNA_INDICE_PLANES_BIENESTAR', doc.data())
              resolve();
            })
          })
      },
      actualizarActivoPlanBienestar({getters}, plan) {
        return new Promise((resolve, reject) => {
        //Consultamos para obtener el plan de bienestar con el id necesitado
        db.collection("Franquicias")
          .doc(getters.franquicia.id).collection("Planes_Bienestar").doc(plan.id).
          get()
          .then(doc => {
            //Modificamos el registro obtenido
            var data = doc.data();
            data.estatus.activo = plan.activo;
            //Volvemos a consultar para actualizar
            console.log("La data nueva desde el store de planes bienestar es: " + data);
            db.collection("Franquicias")
            .doc(getters.franquicia.id).collection("Planes_Bienestar").doc(plan.id).
            update(data);

            resolve(data);
          })
          .catch(error => {
            reject(error)
          });
        });
      },
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/planes_bienestar/planes_bienestar.js